import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'did_workers_work_more_than_80_hours_total'

export const dataPointDefinition = {
  retracedId: 'did_workers_work_more_than_80_hours_total',
  name: 'Did any workers work more than 80 hours in total (regular + overtime) within any given week?',
  description:
    'The intent of this question is to understand if any worker worked more than 80 hours per week in the facility within the assessment period. ',
  meta: {
    slcpMeta: {
      key: 'wh-7--2',
      number: 'WH-WOR-17',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-7--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36280,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
